<div>
  <app-active-learning-campaigns-widget></app-active-learning-campaigns-widget>
</div>